const successMessageTypes = {
    USER_CREATED: 'USER_CREATED',
    USER_INFO_CHANGED: 'USER_INFO_CHANGED',
    COMMISSIONER_CREATED: 'COMMISSIONER_CREATED',
    GENERIC_SUCCESS_MESSAGE: 'GENERIC_SUCCESS_MESSAGE',
};

export default successMessageTypes;
